export function initTiktokPixel(pixelId, sendPageView = true) {
    if (window.ttq) {
      window.ttq.load(pixelId);
      if (sendPageView) window.ttq.page()
      console.log(`Tiktok Pixel ${pixelId} initialized.`);
    } else {
      console.error('Tiktok Pixel not loaded.');
    }
  }
  
  export function trackEventTiktok(eventName, eventData = {}) {
    if (window.ttq) {
      window.ttq.track(eventName, eventData);
    } else {
      console.error('Tiktok Pixel not loaded.');
    }
  }
  
  export function trackEventSingleTiktok(pixelId, eventName, eventData = {}) {
    if (window.ttq) {
      window.ttq.load(pixelId);
      window.ttq.track(eventName, eventData);
    } else {
      console.error('Tiktok Pixel not loaded.');
    }
  }